export type Step = {
  path: string;
  index: number;
};

export type ScheduleSteps = {
  [index: string]: Step;
};

export function getMaxScheduleStepIndex(): number {
  const indexes = Object.values(scheduleSteps).map((step) => step.index);

  return Math.max(...indexes);
}

export const scheduleSteps: ScheduleSteps = {
  back: { path: '', index: -1 },
  pickDate: { path: '/schedule/pick-date', index: 1 },
  professionalsList: { path: '/schedule/professionals-list', index: 1 },
  professional: { path: '/schedule/professional', index: 2 },
  pickSlot: { path: '/schedule/pick-slot', index: 2 },
  signinSignup: { path: '/signin/', index: 3 },
  patientSelection: { path: '/schedule/patient-selection', index: 4 },
  summary: { path: '/schedule/riepilogo', index: 5 },
};

export function customPathScheduleStep(path: string, step: Step) {
  return { ...step, path: step.path + path };
}
